import {
    APP_BACK_HIDE,
    APP_BACK_SHOW,
    APP_DONE,
    APP_RESET,
    APP_SET_BACK_PAGE,
    APP_SET_CONFIG,
    APP_SET_LANGUAGE,
    APP_SET_PLATE,
    APP_SET_ROUTE,
    APP_SET_ROUTE_DONE,
    APP_SET_TAB,
    APP_WAIT
} from "../../constants/action-types";

export function appBackHide(){
    return { type: APP_BACK_HIDE } }

export function appBackShow(){
    return { type: APP_BACK_SHOW } }

export function appDone(){
    return { type: APP_DONE } }

export function appReset(){
    return { type: APP_RESET } }

export function appSetBackPage(page){
    return { type: APP_SET_BACK_PAGE, payload: page } }

export function appSetConfig(config){
    return { type: APP_SET_CONFIG, payload: config } }    

export function appSetLanguage(language){
    return { type: APP_SET_LANGUAGE, payload: language } }

export function appSetPlate(plate){
    return { type: APP_SET_PLATE, payload: plate } }

export function appSetRoute(route){
    return { type: APP_SET_ROUTE, payload: route } }

export function appSetRouteDone(){
    return { type: APP_SET_ROUTE_DONE } }

export function appSetTab(tab){
    return { type: APP_SET_TAB, payload: tab } }

export function appWait(){
    return { type: APP_WAIT } }



// WEBPACK FOOTER //
// ./src/store/actions/app.js